import { WidgetTabsContext } from '@pages/AdditionalServices/containers/widgetTabsContext';
import { shortLinkService } from '@services/requests/shortLinkService';

import { getSavedServiceRestoreByServiceId } from '../helpers';
import { shareContext$ } from '../shareContext';

export const extractRestoreDataFromStorageSubscriber = async (tabsState: WidgetTabsContext) => {
  const savedServiceRestore = getSavedServiceRestoreByServiceId(
    tabsState.ActiveTabData.data?.id ?? ''
  );

  try {
    const storageShortLinkData = await shortLinkService().LoadShortLink({
      id: savedServiceRestore ?? '',
    });

    const storageShareData = JSON.parse(storageShortLinkData?.data ?? 'null');

    shareContext$.next({
      ...shareContext$.getValue(),
      IsStorageShareLoading: false,
      StorageShareData: storageShareData,
      StorageShareShortLink: savedServiceRestore ?? null,
    });
  } catch (e) {
    console.log(e);
  }
};
